import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PromotionHistoryRow {
  id: string;
  shop_id: string;
  component: string;
  condition_type: string;
  from_stage: string | null;
  to_stage: string;
  action: 'promote' | 'demote' | 'hard_demote' | 'manual_revert';
  reason: any;
  metrics_snapshot: any;
  triggered_by: 'engine' | 'manager';
  triggered_by_user_id: string | null;
  created_at: string;
}

export function usePromotionHistory(
  shopId: string | null,
  filter?: { component?: string; condition?: string; limit?: number },
) {
  return useQuery({
    queryKey: ['dvi-promotion-history', shopId, filter?.component, filter?.condition, filter?.limit],
    queryFn: async (): Promise<PromotionHistoryRow[]> => {
      let q = supabase
        .from('dvi_promotion_history' as any)
        .select('*')
        .eq('shop_id', shopId!)
        .order('created_at', { ascending: false })
        .limit(filter?.limit ?? 50);
      if (filter?.component) q = q.eq('component', filter.component);
      if (filter?.condition) q = q.eq('condition_type', filter.condition);
      const { data, error } = await q;
      if (error) throw error;
      return (data ?? []) as unknown as PromotionHistoryRow[];
    },
    enabled: !!shopId,
    staleTime: 30_000,
  });
}
